var Usuario = /** @class */ (function () {
    function Usuario() {
    }
    return Usuario;
}());
export { Usuario };
